import * as React from 'react';
import { Link } from 'react-router-dom';
import * as ReactDOM from 'react-dom';

import { IUser } from '../../types/user';
import { IListItemProps } from '../../types/list_item_props';
import { categories } from '../../../app/helpers/category_helper';
import { formatDate, formatViews } from '../../../app/helpers/format_helper';
import { getLinkForCard } from '../../../app/helpers/link_card_helper';
import { AuthorBlock } from '../author_block/author_block';
import { DeclineReason } from '../decline_reason/decline_reason';
import { unescapeHtml, makeHTMLFromString } from '../../../app/helpers/make_html_helper';
import { Permission } from '../../../app/permissions/permission';
import { getPrioritizedRegion } from '../../../app/helpers/regions_helper';
import { IRegion } from '../../types/posts';

import s from './blog_list_item.css';

interface IProps {
  currentUser: IUser;
  regionId?: string;
  item: IListItemProps;
  saveScroll?(item: any): void;
  selectedItem?: IListItemProps;
  scrollComments(): void;
}

interface IState {
  isVisited?: boolean;
  isHover?: boolean;
}

const types: { [key: string]: { link: string; name: string } } = {
  '': { link: '', name: '' },
  question: { link: '/forum-rieltorov', name: 'Вопросы риелтору' },
  questions: { link: '/forum-rieltorov', name: 'Вопросы риелтору' },
  blog: { link: '/blogs', name: 'Блоги' },
  blogs: { link: '/blogs', name: 'Блоги' },
};

export class BlogListItem extends React.Component<IProps, IState> {
  public linkCard: HTMLAnchorElement | null;

  public constructor(props: IProps) {
    super(props);
    this.state = {
      isVisited: false,
      isHover: false,
    };
  }

  public componentDidMount() {
    this.setState({
      isVisited: this.isVisited(),
    });

    if (this.props.selectedItem && this.props.selectedItem.id === this.props.item.id) {
      this.scrollToEl();
    }
  }

  public render() {
    const { attributes, id } = this.props.item;
    const type = attributes.type || this.props.item.type.toLowerCase();
    const typeObject = types[type];
    const permission = new Permission(this.props.currentUser, { item: this.props.item });

    const isDeclined =
      attributes.status === 'decline' || attributes.status === 'hidden' || attributes.status === 'removed';
    const isAccepted = attributes.status === 'checked' || attributes.status === 'unchecked';
    const statusStyle = isDeclined ? s['decline'] : isAccepted ? s['accepted'] : s['draft'];

    const canSeeCaptions = permission.canSeeCaptions();

    return (
      <article
        className={`
            ${s['advice-list-article']}
            ${statusStyle}
            ${this.state.isVisited ? s['advice-list-article-visited'] : null}
            ${this.state.isHover ? s['advice-list-article-hover'] : null}
            ${attributes.imageThumbnail ? s['has-img'] : null}
          `}
      >
        {attributes.imageThumbnail && (
          <Link
            className={`
              ${s['advice-list-article-image']}
              ${this.state.isVisited ? s['advice-list__item-link_img-visited'] : null}
            `}
            to={getLinkForCard(id, type, attributes.slug)}
            onMouseOver={this.onHover}
            onMouseOut={this.offHover}
            onClick={this.selectedElement}
          >
            <img src={attributes.imageThumbnail} alt={attributes.title} itemProp="image" />
          </Link>
        )}
        <nav className={s['advice-list-article-nav']}>
          {typeObject.link && (
            <Link
              className={this.state.isVisited ? s['advice-list__item-link_category-visited'] : undefined}
              to={`${typeObject.link}/`}
            >
              {typeObject.name}
            </Link>
          )}
          {typeObject.link && categories[attributes.category || ''].link && (
            <Link
              className={this.state.isVisited ? s['advice-list__item-link_subcategory-visited'] : undefined}
              to={`${typeObject.link}-${categories[attributes.category || ''].link}/`}
            >
              {categories[attributes.category || ''].name}
            </Link>
          )}
          {canSeeCaptions && <span className={s['advice-list-article-nav_accepted']}>опубликовано</span>}
          {canSeeCaptions && <span className={s['advice-list-article-nav_decline']}>отклонён</span>}
          {canSeeCaptions && <span className={s['advice-list-article-nav_draft']}>черновик</span>}
        </nav>
        {isDeclined && <DeclineReason blockReason={attributes.blockReason} />}
        <Link
          to={`${getLinkForCard(id, type, attributes.slug)}`}
          className={`
              ${s['advice-list-article_heading']}
              ${this.state.isVisited ? s['advice-list__item_link-visited'] : ''}
              ${this.state.isHover ? s['advice-list-article_heading-hover'] : ''}
            `}
          onMouseOver={this.onHover}
          onMouseOut={this.offHover}
          onClick={this.selectedElement}
        >
          {unescapeHtml(attributes.title)}
        </Link>
        <p className={s['advice-list-article_text']}>
          <Link
            className={`
                ${s['list-item__link']}
                ${this.state.isVisited ? s['advice-list__item_link-visited'] : null}
              `}
            to={`${getLinkForCard(id, type, attributes.slug)}`}
            ref={linkCard => (this.linkCard = linkCard)}
            onMouseOver={this.onHover}
            onMouseOut={this.offHover}
            onClick={this.selectedElement}
          >
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={makeHTMLFromString(attributes.subtitle)} />
          </Link>
        </p>
        {attributes.authorObject && <AuthorBlock author={attributes.authorObject} />}
        <div className={s['post-info']} itemProp="hasPart" itemScope itemType="http://schema.org/PublicationIssue">
          {type === 'questions' && (
            <span className={s['list-item__date']}>
              <span itemProp="datePublished">{formatDate(attributes.datePublish)}</span>
              <span>
                ・
                {attributes.regions && attributes.regions.length > 0
                  ? (getPrioritizedRegion(attributes.regions, this.props.regionId) as IRegion).name
                  : 'Вся Россия'}
              </span>
            </span>
          )}
          {type === 'blogs' && (
            <span className={s['list-item__date']} itemProp="datePublished">
              {formatDate(attributes.datePublish)}
            </span>
          )}
          <span className={s['list-item__views']}>
            <span className={s['views-icon']} />
            <span>{formatViews(attributes.numViews, 3)}</span>
          </span>
          {(type === 'questions' || attributes.commentsCount > 0) && (
            <Link
              to={`${getLinkForCard(id, type, attributes.slug)}`}
              className={s['list-item__comments']}
              onClick={this.props.scrollComments}
            >
              <span className={s['comments-icon']} />
              <span>{formatViews(attributes.commentsCount, 3)}</span>
            </Link>
          )}
          {type === 'blogs' && (
            <span className={s['advice-list-article-footer_likes']}>{attributes.likesCount || 0}</span>
          )}
          {type === 'blogs' && (
            <span className={s['advice-list-article-footer_dislikes']}>{attributes.dislikesCount || 0}</span>
          )}
        </div>
      </article>
    );
  }

  private isVisited() {
    const { attributes, id } = this.props.item;
    const visitedLinks = localStorage['visitedLinks'] ? JSON.parse(localStorage['visitedLinks']) : [];
    const type = attributes.type || this.props.item.type;

    return visitedLinks.includes(getLinkForCard(id, type, attributes.slug));
  }

  private onHover = () => {
    this.setState({ isHover: true });
  };

  private offHover = () => {
    this.setState({ isHover: false });
  };

  private selectedElement = () => {
    if (this.props.saveScroll) {
      this.props.saveScroll(this.props.item);
    }
  };

  private scrollToEl = () => {
    // eslint-disable-next-line react/no-find-dom-node
    const node = ReactDOM.findDOMNode(this);
    if (node && node instanceof Element) {
      node.scrollIntoView();
    }
  };
}
